(() => {
  if (window.__marcosStoreHours) return;
  window.__marcosStoreHours = true;

  // Hours belong to the shops in New Jersey, regardless of the visitor's zone.
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  });
  const hours = {
    Sun: [540, 1020, 'grand'], Mon: [480, 1140], Tue: [480, 1140],
    Wed: [480, 1140], Thu: [480, 1140], Fri: [480, 1140], Sat: [540, 1020],
  };

  function update() {
    const parts = Object.fromEntries(formatter.formatToParts(new Date()).map(part => [part.type, part.value]));
    const range = hours[parts.weekday];
    const minutes = Number(parts.hour) * 60 + Number(parts.minute);
    const open = Boolean(range && minutes >= range[0] && minutes < range[1]);
    document.querySelectorAll('[data-store-status]').forEach(badge => {
      const label = badge.querySelector('[data-store-status-label]');
      if (!label) return;
      badge.dataset.open = String(open);
      label.textContent = open
        ? (range[2] === 'grand' ? badge.dataset.i18nOpenGrand : badge.dataset.i18nOpen)
        : badge.dataset.i18nClosed;
    });
  }

  update();
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
  window.setInterval(() => { if (!document.hidden) update(); }, 60000);
})();
